import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "动漫", to: "/category/anime" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-700 text-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight">色虎视频</span>
            </div>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-background-100/90">
              色虎视频是高清影视资源聚合平台，汇聚电影、电视剧、综艺、动漫等多元内容，帮助影迷快速发现、筛选和浏览心仪的影视作品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">内容导航</h3>
            <ul className="mt-3 space-y-2 text-sm text-background-100/90">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">联系我们</h3>
            <ul className="mt-3 space-y-2 text-sm text-background-100/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true" />
                support@sehu-video.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line" aria-hidden="true" />
                工作日 9:00 - 18:00
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-twitter-x-line", "ri-youtube-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50"
                >
                  <i className={icon} aria-hidden="true" />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-primary-600 pt-6 text-xs text-background-100/80 sm:flex-row sm:items-center">
          <p>© {year} 色虎视频 sehu-video.com 保留所有权利。</p>
          <p>本站为影视资源聚合演示平台，内容仅供学习与交流使用。</p>
        </div>
      </div>
    </footer>
  );
}